export const touchpointsMocks = {
  tiktokSliders: {
    budgetShare: {
      min: 0,
      max: 1,
    },
    saturation: {
      min: 0,
      max: 1,
    },
  },
  metaSliders: {
    saturation: {
      min: 0,
      max: 1,
    },
    budgetShareConsideration: {
      min: 0,
      max: 1,
    },
    campaignLengthOptions: [1, 2, 4, 8],
  },
  youTubeSliders: {
    budgetShare: {
      min: 0,
      max: 1,
    },
    saturation: {
      min: 0,
      max: 1,
    },
    skipCpv: {
      min: 0,
      max: 1,
    },
    unSkip: {
      min: 0,
      max: 1,
    },
    bumper: {
      min: 0,
      max: 1,
    },
  },
  tvSliders: {
    weeklyWeightMin: 40,
    weeklyWeightMax: 120,
    weeklyWeightDefault: 50,
  },
};
